<template>
    <vs-row>
        <vs-row vs-justify="center">
            <vs-col vs-lg="4" class="mt-5 pt-5">
                <img src="@/assets/images/logo/logo.png" width="100%" class="logoStyle"/>
            </vs-col>
        </vs-row>
        <vs-row vs-justify="center">
            <h4 class="mb-3">Forgot your password?</h4>
        </vs-row>
        <vs-row vs-justify="center" class="mt-6">
            <vs-col vs-lg="3" class="inputStyle mt-6">
                <div class="mt-6">
                    Please enter the email registered with your account and we will
                    send you a link to reset your password.
                </div>
                <vs-input 
                v-model="email" 
                 type="email"
                placeholder="Email Address"
                 class="w-full"
                 :danger="errors.email.success"
                :danger-text="errors.email.msg"
                 @input="validateEmail($event)"
                 maxLength="40"/>
            </vs-col>
        </vs-row>
        <vs-row vs-justify="center" class="my-6 py-4">
            <vs-col vs-lg="3" class="inputStyle" vs-type="flex" vs-justify="flex-end">
                <vs-button class="w-full py-4 my-6" @click="sendLink">Send Link</vs-button>
            </vs-col>
        </vs-row>
        <vs-popup class="holamundo" title="Status" :active.sync="emailSentStatus">
            <h4>Reset Password link has been sent to your email address</h4>
        </vs-popup>
    </vs-row>
</template>

<script>
import axios from 'axios';
   import { validateEmail } from '@/views/admin/validation';
import { genericErrorMessage, toast } from '@/keys/toast-messages';

export default {
    data(){
        return {
            email: '',

            emailSentStatus: false,

            errors: {
                email: {
                    msg: '',
                    success: false
                }
            },
            validateEmail,

            genericErrorMessage,
            toast
        }
    },
    methods: {
        async sendLink(){
            await this.validateEmail(this.email);
            if(!this.errors.email.success){
                    axios.post(this.$ApiKeys.BASE_URL+this.$EndPoints.ForgotPassword,{
                        email: this.email
                    }).then(async res => {
                        if(res.data.success){
                            this.emailSentStatus = true;
                            this.errors.email = {
                                msg: '',
                                success: false
                            }
                        } else {
                            this.toast(this.genericErrorMessage());
                        }
                    }).catch(e => {
                        if(e.response.data.success == false){
                            this.errors.email = {
                                msg: e.response.data.msg,
                                success: true
                            }
                        } else {
                            if(e.response.status !== 401){
                                this.toast(this.genericErrorMessage());
                            }
                        }
                    });
            }
        },
    }
}
</script>


<style>
.theme-dark .input-icon-validate {
  display: none !important; 
}
.theme-dark .con-text-validation {
  font-size:12px !important;
}

    .logoStyle {
        padding: 15%;
    }
    .inputStyle .vs-input--input, .inputStyle .vs-input--placeholder {
        padding: 4% 4% !important;
        padding-top: 4% !important;
        margin: 5% 0 !important;
    }
     .inputStyle .vs-input--placeholder {
            font-size: 100%;
            margin-top: 35px !important;
     } 
    .signUpLink {
        color:#4B4BF9;
    }
</style>
